// extracted by mini-css-extract-plugin
module.exports = {"subBanner":"subBanner--3Uz6C","mainWidth":"mainWidth--EwLtR","textWrap":"textWrap--2zQ6P","title":"title--2vknx","subtitle":"subtitle--1xAhl","imageWrap":"imageWrap--3t1ys"};